import * as React from 'react';
import { Typography, Card, CardContent, Grid } from '@material-ui/core';

export default class HomePage extends React.Component<{}, {}> {


    constructor(props: {}) {
        super(props);

        this.state = {

        }
    }

    public render() {
        return (
            <Grid container={true} justify="center" spacing={3}>
                <Grid item={true} xs={12} md={8} lg={8}>
                    {/* <Fade in={true}> */}

                    <Card >

                        <CardContent>
                            <Typography gutterBottom={true} variant="h5" component="h2">
                                Are you struggling to find your first customers and investors?
          </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                We provide you with the best startup coaching and funding.
          </Typography>
                        </CardContent>
                    </Card >

                    {/* </Fade> */}
                </Grid>
            </Grid>

        )
    }

}


// WEBPACK FOOTER //
// ./src/components/home/Home.tsx